import React from 'react';
import { clsx } from 'clsx';
import { Controller } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { EditableCard } from './EditableCard';
import { useCompanyInfoForm } from '../hooks/useCompanyInfoForm';

interface CompanyInfoCardProps {
  account: { company_name: string; email: string; phone_number?: string } | undefined;
  editMode: boolean;
  disabled: boolean;
  onEdit: () => void;
  onDone: () => void;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const CompanyInfoCard = ({
  account,
  editMode,
  disabled,
  onEdit,
  onDone,
  onLoadingChange,
}: CompanyInfoCardProps) => {
  const { control, trigger, submit, cancel } = useCompanyInfoForm(account, onDone, onLoadingChange);

  return (
    <EditableCard
      title="Company"
      formId="company-info"
      editMode={editMode}
      disabled={disabled}
      onEdit={onEdit}
      onCancel={cancel}
      onSubmit={submit}
      className={clsx('half-width', editMode && 'z-10')}
    >
      <div className="input-container full-width">
        <Controller
          control={control}
          name="company_name"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="text"
              label="Company Name"
              placeholder="Company"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('company_name');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
      <div className="input-container full-width">
        <Controller
          control={control}
          name="account_phone_number"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="phone"
              label="Phone Number"
              placeholder="+1 (555) 455 88 99"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('account_phone_number');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
      <div className="input-container full-width">
        <Controller
          control={control}
          name="company_email"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="email"
              label="Company Email"
              placeholder="email@company.com"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('company_email');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
    </EditableCard>
  );
};
